export { default } from './AccommodationBlock'
